export const breakpoint: number = 768;

type Layout = 'compact' | 'normal';

export default class LayoutManager {
  static shared = new LayoutManager();
  width: number = 0;
  height: number = 0;
  layout: Layout = 'normal';

  constructor() {
    this.updateSize(true)
  }

  startObserving = () => {
    window.addEventListener('resize', this.onSizeChange)
    this.updateSize()
  }

  stopObserving = () => {
    window.removeEventListener('resize', this.onSizeChange)
  }

  onSizeChange = (event: UIEvent) => {
    this.updateSize()
  }

  updateSize = (firstUpdate: boolean = false) => {
    const w = window;
    const d = document;
    const de = d.documentElement;
    const b = d.getElementsByTagName('body')[0];
    const oldWidth = this.width;
    const newWidth = w.innerWidth || de.clientWidth || b.clientWidth;
    const newHeight = w.innerHeight || de.clientHeight || b.clientHeight;
    this.width = newWidth;
    this.height = newHeight;
    if (firstUpdate) {
      if (newWidth <= breakpoint) {
        this.layout = 'compact';
      } else {
        this.layout = 'normal';
      }
      window.dispatchEvent(new Event('repeatLayoutChange'));
    } else {
      if ((newWidth <= breakpoint && oldWidth > breakpoint) || (newWidth > breakpoint && oldWidth <= breakpoint)) {
        if (newWidth > breakpoint) {
          this.layout = 'normal';
        } else {
          this.layout = 'compact'
        }
        window.dispatchEvent(new Event('repeatLayoutChange'));
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/LayoutManager.ts